import { Injectable } from "@angular/core";
import { HttpHeaders } from "@angular/common/http";
import { SnackBarService } from "./snack.bar.service";
import { tap } from "rxjs/operators";
import { AccountNameGQL, GetNonAdminAccountListGQL, CheckPlatformUserIsAdminGQL, GetAccountListGQL, GetPlatformUserProfileGQL, UpdatePlatformUserProfileGQL } from "../../../generated/graphql";
import { GraphQLError } from "graphql";
import { Observable } from "rxjs";
import { FetchResult } from "apollo-link";
import JSEncrypt from "jsencrypt";
import { environment } from "../../../environments/environment";
import * as JWT from "../../../../node_modules/jwt-decode/lib";

@Injectable()
export class UserService {
  public UserProfile: any;
  public AccountName: any;
  public AccountList: any = [];
  public AssignedAccountIds: any = [];
  isAdmin: boolean = false;
  platformUserId: string;

  constructor(
    private accountNameGQL: AccountNameGQL,
    private getAccountListGQL: GetAccountListGQL,
    private snackSvc: SnackBarService,
    private getNonAdminAccountListGQL: GetNonAdminAccountListGQL,
    private checkPlatformUserIsAdminGQL: CheckPlatformUserIsAdminGQL,
    private getPlatformUserProfileGQL: GetPlatformUserProfileGQL,
    private updatePlatformUserProfileGQL : UpdatePlatformUserProfileGQL
  ) {}

  public Init() {
    this.GetProfile();
    this.GetAccountName();
    this.getPlatfromUserId();
    this.checkIsAdminPlatformUser();     
    this.getAccountList();
  }

  public GetAccountName() {
    this.accountNameGQL.fetch().subscribe((result) => {
      this.AccountName = result.data.getAccountName;
    });
  }
  public GetProfile() {
    this.getPlatformUserProfileGQL.fetch().subscribe((result) => {
      if (result?.errors) {
        this.snackSvc.showQueryError(result.errors);
      }
      this.UserProfile = result.data.getPlatformUserProfile;
    })
  }
  private getAccountList() {
    this.getAccountListGQL.fetch().subscribe((result) => {
      this.snackSvc.showQueryError(result.errors);
      if (result.errors) {
        this.AccountList = [];
      } else {
        this.AccountList = result.data.getAccountList;
        this.getAssignedAccountList(this.isAdmin);
      }
    });
  }

  getAssignedAccountList(isAdmin: boolean) {
    if (!isAdmin) {
      this.getNonAdminAccountListGQL
        .fetch({
          userId: this.platformUserId,
        })
        .subscribe((result) => {
          this.AssignedAccountIds = result.data.getNonAdminAccountList;
          if (this.AssignedAccountIds.length > 0) {
            this.AccountList = this.AccountList.filter((x) => {
              return this.AssignedAccountIds.some((y) => {
                return y.ID == x.id;
              })
            });
          } else {
            this.AccountList = [];
            this.snackSvc.show(
              "Error! NO Subscription Account Assign to you yet!.",
              null,
              { duration: 2000 }
            );
          }
        });
    }
  }

  checkIsAdminPlatformUser() {
      this.checkPlatformUserIsAdminGQL
        .fetch({ userId: this.platformUserId })
        .subscribe((result) => {          
          this.isAdmin = result.data.checkPlatformUserIsAdmin;
        });  
  }

  getPlatfromUserId() {
    let token = sessionStorage.getItem("JwtAccessToken");
    if (token) { 
      let decoded = JWT(token);
      this.platformUserId = decoded["userID"];
    }
  }

  public ProfileUpdate(value: any) {
    if (!value.Name && !value.Email && !value.Mobile) {
      let err = new Error("Argument null exception");
      console.error(err, value);

      return;
    }

     return this.updatePlatformUserProfileGQL.mutate({
        input: {
            name: value.Name,
            contactNo: value.Mobile,
            avatar: value.file
        }
    }, {
        context: {
            useMultipart: true
        }
    }).pipe(
        tap(
            () => this.snackSvc.show("Profile updated successfully.", null, { duration: 2000 }
            ), (err) => {
                this.snackSvc.show(err.message.split(":")[2] || "Failed to update profile.");
            }
        )
    );
  }

  public ChangePassword(value: any) {
    if (
      !value.CurrentPassword &&
      !value.NewPassword &&
      !value.ConfirmPassword
    ) {
      let err = new Error("Argument null exception");
      console.error(err, value);
      return;
    }

    // return this.changePasswordGQL.mutate({
    //     input: {
    //         oldPassword:  this.PasswordEncrypt(value.CurrentPassword),
    //         newPassword:  this.PasswordEncrypt(value.NewPassword),
    //         confirmPassword:  this.PasswordEncrypt(value.ConfirmPassword)
    //     }
    // }).pipe(
    //     tap(
    //         () => {
    //             this.snackSvc.show('Password Changed!', null, { duration: 2000 });
    //         }, (err: GraphQLError) => {
    //             this.snackSvc.show(err.message.split(":")[1] || "Failed to change password.");
    //         }
    //     )
    // );
  }

  public VerifyNewPasswordState(queryParam: string) {
    // return this.newPasswordCheckGQL.mutate(null, {
    //     context: {
    //         headers: new HttpHeaders().set('Authorization', `Bearer ${queryParam}`)
    //     }
    // });
  }

  public PasswordEncrypt(password: string): string {
    let jsEncrypt = new JSEncrypt();
    jsEncrypt.setPublicKey(environment.PasswordPublicKey);
    return jsEncrypt.encrypt(password);
  }

  public SetNewPassword(value: any) {
    if (!value.QueryParam && !value.NewPassword && !value.ConfirmPassword) {
      let err = new Error("Argument null exception");
      console.error(err, value);
      return;
    }

    // return this.newPasswordGQL.mutate({
    //     newPassword: this.PasswordEncrypt(value.NewPassword),
    //     confirmPassword: this.PasswordEncrypt( value.ConfirmPassword)
    // }, {
    //     context: {
    //         headers: new HttpHeaders().set('Authorization', `Bearer ${value.QueryParam}`)
    //     }
    // }).pipe(
    //     tap(
    //         () => this.snackSvc.show("Password Set!", null, { duration: 2000 }),
    //         (err: GraphQLError) => {
    //             this.snackSvc.show(err.message.split(":")[1] || "Set password failed.");
    //         }
    //     )
    // );
  }
  //#endregion
}
